import { useTranslation } from "react-i18next";

import { Dialog } from "./Dialog";
import * as svg from "./svg";
import { CartError } from "../types/Cart";

export const CartErrorDialog = ({
    onOk,
    error
}: {
    onOk: () => void;
    error: CartError;
}) => {
    const { t, i18n } = useTranslation();
    const bodyKey = `cartError.${error.case}.body`;

    return (
        <Dialog
            dataTestId="cartErrorDialog"
            image={svg.productNotFound}
            title={t([`cartError.${error.case}.title`, "productNotFound"])}
            primaryButton={{ title: t("okDismiss"), action: onOk }}
        >
            {i18n.exists(bodyKey) && (
                <p className="text-center font-light text-primary-800">
                    {t(bodyKey)}
                </p>
            )}
        </Dialog>
    );
};
